import { Mutation } from './types'

export default {
    [Mutation.SAVE_DOMAINS](state, result) {
        state.domains = result;
        state.status = 'done'
    }
}